import { defaultUserImagePath, gikClassPrefix } from "@gik/core/constants";
import bemBlock from "@gik/core/utils/bemBlock";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { KeepProportions, Square } from "@gik/ui-legacy/KeepProportions";
import classnames from "classnames";
import type React from "react";
import { useState } from "react";

interface TeamTileProps {
	name: string;
	title: string;
	altTitle?: string;
	photo?: string;
	altPhoto?: string;
	flipEnabled?: boolean;
}

const blockName = "team-tile";
const prefixedBlockName = `${gikClassPrefix}-${blockName}`;

const TeamMemberTileComp: React.FunctionComponent<TeamTileProps> = ({
	name,
	title,
	altTitle,
	photo,
	altPhoto,
}: React.PropsWithChildren<TeamTileProps>) => {
	const [showBack, setShowBack] = useState<boolean>(false);

	const bem = bemBlock(blockName);

	const handleFlip = () => {
		if (altPhoto) {
			setShowBack(!showBack);
		}
	};

	const classNames = classnames([
		{ [prefixedBlockName]: true },
		showBack
			? `${prefixedBlockName}--show-back`
			: `${prefixedBlockName}--show-front`,
		{ [`${prefixedBlockName}--flip-enabled`]: altPhoto },
	]);

	return (
		<div className={classNames} onClick={handleFlip}>
			<div className={bem("photo")}>
				<KeepProportions proportion={Square} className={bem("photo-front")}>
					<div
						className={bem("photo-element")}
						style={{
							backgroundImage: photo ? `url('${photo}')` : defaultUserImagePath,
						}}
					/>
				</KeepProportions>
				<KeepProportions proportion={Square} className={bem("photo-back")}>
					<div
						className={bem("photo-element")}
						style={{
							backgroundImage: altPhoto
								? `url('${altPhoto}')`
								: defaultUserImagePath,
						}}
					/>
				</KeepProportions>
			</div>
			<div className={bem("name")}>{name}</div>
			<div className={bem("title")}>
				<span className={bem("title-front")}>{title}</span>
				{altTitle && <span className={bem("title-back")}>{altTitle}</span>}
			</div>
		</div>
	);
};

export const TeamMemberTile = withComponentErrorBoundary(TeamMemberTileComp);
